import {animate, state, style, transition, trigger, query} from '@angular/animations';

const speed = '900ms ease-in-out';

export const AnimationsMetaData = [

  trigger('routing', [
    state('*', style({position: 'absolute', width: '100%', overflow: 'hidden', left: 0 })),
    transition('void => backward', [
      animate(speed, style({
        transform: 'translateX(-100%)'
      }))
    ]),
    transition('backward => void', [
      animate(speed, style({
        transform: 'translateX(100%)'
      }))
    ]),
    transition('void => forward', [
      animate(speed, style({
        transform: 'translateX(100%)'
      }))
    ]),
    transition('forward => void', [
      animate(speed, style({
        transform: 'translateX(-100%)'
      }))
    ]),
    transition('void => upward', [
      animate(speed, style({
        transform: 'translateY(-100%)'
      }))
    ]),
    transition('upward => void', [
      animate(speed, style({
        transform: 'translateY(100%)'
      }))
    ]),
    transition('* => downward', [
      animate(speed, style({
        transform: 'translateY(100%)'
      }))
    ]),
    transition('downward => void', [
      animate(speed, style({
        transform: 'translateY(-100%)'
      }))
    ])
  ])
];



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/_animations/animations.metadata.ts